export const UserSource = {
  SmartOnFhir: 'smartOnfhir'
};
